import React from 'react';
import { useQuery } from '@tanstack/react-query';
import useApiClient from '../../hooks/useApiClient';
import TreeSelectDropdown from '../dropdowns/treeSelectDropdown';
import { QUERY_OPTIONS_LOAD_ONCE } from '../../apiUtils';
import { TreeSelectDropdownSmartWrapperProps } from '../dropdowns/types';
import { DeploymentTreeNode } from '../../apiClient';
import { renderNodeIconAndName } from './util';

export const RealAssetDeploymentTreeDropdown: React.FC<TreeSelectDropdownSmartWrapperProps<DeploymentTreeNode>> = (props) => {
    const api = useApiClient();

    const { data: deploymentTree, isLoading: deploymentsAreLoading } = useQuery({
        queryKey: ["realAssetDeploymentTree"],
        queryFn: () => api.dataAccess.listRealAssetDeploymentTree(),
        ...QUERY_OPTIONS_LOAD_ONCE,
    });

    return (
        <TreeSelectDropdown
            label={props.label || "Real Asset Deployment"}
            options={deploymentTree?.tree || []}
            selectedIds={props.selectedIds || []}
            onOptionToggle={props.onOptionToggle}
            isLoading={deploymentsAreLoading}
            labelClassName={props.labelClassName}
            dropdownClassName={props.dropdownClassName}
            enableSearch={props.enableSearch}
            initiallyExpanded={props.initiallyExpanded}
            showHideUnselectedToggle={props.showHideUnselectedToggle || false}
            renderNode={(node: any) => renderNodeIconAndName(node, (node: any) => node.real_asset?.type)}
        />
    );
};

export default RealAssetDeploymentTreeDropdown;